import { usePromotionCampaignsQuery } from "@shared/data/queries/PromotionCampaignsQuery/PromotionCampaigns.query";

import { useSharedGlobalConfig } from "../useSharedGlobalConfig/useSharedGlobalConfig";

const CYBER_MONDAY_KEY = "CM23WS";

const useCyberMondayEnabled = (isWholesaleEnabled: boolean) => {
  const { isUnauthenticated } = useSharedGlobalConfig();

  const { data, loading } = usePromotionCampaignsQuery({
    fetchPolicy: "network-only", // keeping this network only so it can always get the most up-to-date result for the active state
    skip: isUnauthenticated || !isWholesaleEnabled,
  });

  const campaigns = data?.currentOffice?.promotionCampaigns;
  const result = campaigns?.find(campaign => campaign.name === CYBER_MONDAY_KEY);
  const isActive = result?.isActive || false;

  return {
    loading,
    isCyberMondayEnabled: isActive,
  };
};

export { useCyberMondayEnabled, CYBER_MONDAY_KEY };
